import { User, MapPin } from "lucide-react";
import ClientsDropdown from "../inputs/ClientsDropdown";

interface ClientSectionProps {
  formData: any;
  setFormData: (data: any) => void;
  selectedClient: any;
  handleClientChange: (clientId: number | null, client?: any) => void;
  handlePlecareSerparata: (checked: boolean) => void;
  dropdownsData: any;
}

const ClientSection: React.FC<ClientSectionProps> = ({
  formData,
  setFormData,
  selectedClient,
  handleClientChange,
  handlePlecareSerparata,
  dropdownsData
}) => {
  return (
    <div className="bg-gradient-to-r from-orange-50 to-red-50 rounded-xl p-4 border border-orange-200 shadow-sm">
      <div className="flex items-center mb-3">
        <div className="p-2 bg-orange-500 rounded-lg mr-3">
          <User className="w-4 h-4 text-white" />
        </div>
        <h3 className="font-semibold text-gray-800 text-lg">Client</h3>
      </div>

      <div className="space-y-3">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Client *
          </label>
          <ClientsDropdown
            value={formData.client_id || null}
            onChange={handleClientChange}
            required
            clients={dropdownsData.clients}
          />
        </div>

        {/* Show client address info */}
        {selectedClient && selectedClient.address && (
          <div className="p-3 bg-blue-50 rounded-lg border border-blue-200">
            <div className="flex items-start">
              <MapPin className="w-4 h-4 text-blue-600 mt-0.5 mr-2 flex-shrink-0" />
              <div className="min-w-0">
                <p className="font-medium text-blue-800 text-sm">
                  Adresa firmei 
                  {!formData.plecare_separata && (
                    <span className="text-blue-600 ml-1">(locație plecare)</span>
                  )}
                </p>
                <p className="text-blue-700 text-sm break-words">
                  {selectedClient.address}
                  {selectedClient.city && `, ${selectedClient.city}`}
                </p>
              </div>
            </div>
            
            {/* Show when this address is used as departure */}
            {!formData.plecare_separata && (
              <div className="mt-2 p-2 bg-green-50 rounded border border-green-200">
                <div className="flex items-center">
                  <div className="w-2 h-2 bg-green-500 rounded-full mr-2"></div>
                  <span className="text-xs text-green-700 font-medium">
                    Această adresă va fi folosită ca punct de plecare
                  </span>
                </div>
              </div>
            )}
          </div>
        )}

        {selectedClient && (
          <div className="flex items-center">
            <input
              type="checkbox"
              id="plecare-separata"
              checked={formData.plecare_separata || false}
              onChange={(e) => handlePlecareSerparata(e.target.checked)}
              className="w-4 h-4 text-orange-600 border-gray-300 rounded focus:ring-orange-500"
            />
            <label htmlFor="plecare-separata" className="ml-2 text-sm text-gray-700">
              Plecare din altă locație (nu din sediul firmei)
            </label>
          </div>
        )}
      </div>
    </div>
  );
};

export default ClientSection;